import React, { Fragment } from 'react';
import Transfer from './transfer';

const LotScheduleTransfers = ({ transfers, lot }) => (
  <Fragment>
    {transfers.map(t => (
      <Transfer transfer={t} lot={lot} />
    ))}
  </Fragment>
);

export default LotScheduleTransfers;



// WEBPACK FOOTER //
// ./src/components/lotScheduleTransfers/lotScheduleTransfers.jsx